import { useCallback } from 'react';
import useTranslation from 'next-translate/useTranslation';

import type { MyUserContest } from '../types/userContest';

type ActionBannerColor = 'red' | 'yellow' | 'gray';

const STATUS_BANNER_COLORS: Record<string, ActionBannerColor> = {
  action_required: 'red',
  warning: 'yellow',
};

function useGetActionBannerInfo() {
  const { t } = useTranslation('contest');

  const getActionBannerInfo = useCallback(
    (
      alerts: MyUserContest['alerts'] | undefined
    ): { color: ActionBannerColor; content: string } | undefined => {
      if (alerts?.values?.length) {
        const [firstAlert] = alerts.values;
        const alertCount = alerts.values.length;

        let content = firstAlert?.message;

        if (alertCount > 1) {
          const additionalCount = alertCount - 1;
          content += ` + ${t('common.contestCard.banner.alert__hasPlural', {
            count: additionalCount,
          })}`;
        }

        return {
          color: STATUS_BANNER_COLORS[firstAlert.status] ?? 'gray',
          content,
        };
      }

      return undefined;
    },
    []
  );

  return { getActionBannerInfo };
}

export default useGetActionBannerInfo;
